<template>
    <fragment>
        <YouAndMeTextIndex/>
        <YouAndMeTextAdmin/>
        <YouAndMeTextSettings/>
        <YouAndMeTextWooCommerce/>
        <TxProductStats/>
    </fragment>
</template>

<script>
    import YouAndMeTextWooCommerce from "./__partials__/YouAndMeTextWooCommerce";
    import YouAndMeTextSettings from "./__partials__/YouAndMeTextSettings";
    import YouAndMeTextIndex from "./__partials__/YouAndMeTextIndex";
    import YouAndMeTextAdmin from "./__partials__/YouAndMeTextAdmin";

    let layout = lovemap.vue_env;

    export default {
        name: "index",
        layout: layout,
        components: {
            YouAndMeTextAdmin,
            YouAndMeTextIndex,
            YouAndMeTextSettings,
            YouAndMeTextWooCommerce
        }
    }
</script>

<style scoped>

</style>
